<span *ngIf="errorMessage" class="form-group__error" [@slideUpDown]>{{
  errorMessage
}}</span>
